import React from 'react'
import Cpapforsleep from '../component/Cpapforsleep'
import Manual from '../component/Manual'
import Topmostpopular from '../component/Topmostpopular'
import Typesofsleepapnea from '../component/Typesofsleepapnea'
import Sleep from '../component/Sleep'
import Whatdoyouneed from '../component/Whatdoyouneed'
import Yourneed from '../component/Yourneed'
import Stayintouch from '../component/Stayintouch'
import Resmed from '../component/Resmed'
import Footer from '../component/Footer'


const CpapMachines = () => {
  return (
    <div className='lg:mx-10 md:mx-5 mx-3 mt-[120px]'>
     
      <Cpapforsleep/>
      <Manual/>
      <Topmostpopular/>
      <Typesofsleepapnea/>
      <Sleep/>
        <Yourneed/>  
        <Whatdoyouneed/>
        <Stayintouch/>      
        <Resmed/>
    
      <Footer/>
   
    </div>
  )
}

export default CpapMachines
